// App.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import Certified from "./pages/Certified"
import Home from "./pages/Home"
import Hours from "./pages/Hours"
import Login from "./pages/Login"
import Register from "./pages/Register"
import NoPage from "./pages/NoPage"
import Layout from "./pages/Layout"
import ContactUs from "./pages/ContactUs"
import Profile from "./pages/Profile"
import SearchResults from "./pages/SearchResults"

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="VolunteerHours" element={<Hours />} />
          <Route path="GetCertified" element={<Certified />} />
          <Route path="*" element={<NoPage />} />
          <Route path="Login" element={<Login />} />
          <Route path="Register" element={<Register />} />
          <Route path="ContactUs" element={<ContactUs />} />
          <Route path="Profile" element={<Profile />} />
          <Route path="search" element={<SearchResults />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
